import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Grid, makeStyles } from "@material-ui/core";

import { StatusCard } from "./statusCard";
import { BuildingCard } from "./buildingCard";
import { COLORS } from "../../../../../../theme/colors";
import { CARD_VIEWS_STATUSES } from "../../../../../../services/constants";
import { BOPFlow } from "../../../flows";

const useStyles = makeStyles(() => ({
  column: {
    "-ms-overflow-style": "none",
    "scrollbar-width": "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export const BuildingStatusView = ({ buildings, statusCount, onReload }) => {
  const classes = useStyles();
  const [openFlow, setOpenFlow] = useState(false);
  const [selectedBuilding, setSelectedBuilding] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const id = searchParams.get("id");
    if (buildings && id) {
      const filteredBuildings = buildings.filter((building) => building.id === +id);
      if (filteredBuildings.length) {
        setOpenFlow(true);
        setSelectedBuilding(filteredBuildings[0]);
      }
    }
  }, [buildings]);

  return (
    <>
      <Grid container spacing={3} justifyContent="space-between">
        {Object.entries(CARD_VIEWS_STATUSES).map(([statusKey, status], i) => (
          <Grid key={i} item xs={3}>
            <StatusCard name={status.name} number={statusCount[statusKey]} icon={status.icon} />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3} justifyContent="space-between">
        {Object.keys(CARD_VIEWS_STATUSES).map((statusKey, i) => (
          <Grid key={i} item xs={3}>
            <Box
              className={classes.column}
              bgcolor={COLORS.whites[50]}
              border={`2px dashed ${COLORS.darks[0][10]}`}
              borderRadius={8}
              mb={4}
              height={900}
              overflow="auto"
            >
              {buildings
                .filter((b) => b.onboarding_status === statusKey.toUpperCase())
                .map((building, i) => (
                  <BuildingCard
                    key={i}
                    building={building}
                    onClick={(b) => {
                      setSelectedBuilding(b);
                      setOpenFlow(true);
                    }}
                  />
                ))}
            </Box>
          </Grid>
        ))}
      </Grid>

      <BOPFlow
        open={openFlow}
        selectedBuilding={selectedBuilding}
        onClose={() => {
          setOpenFlow(false);
          onReload();
          if (searchParams.has("id")) {
            searchParams.delete("id");
            setSearchParams(searchParams);
          }
        }}
      />
    </>
  );
};
